import { render, staticRenderFns } from "./fapiaoset.vue?vue&type=template&id=f9f0f964&scoped=true"
import script from "./fapiaoset.vue?vue&type=script&lang=js"
export * from "./fapiaoset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f0f964",
  null
  
)

export default component.exports